<template>
    <div :id="this.$route.name">
        <card back>
            <template v-slot:header>
                <h4 class="d-inline">{{ title }}</h4>
                <hr />
            </template>
            <template v-slot:content>
                <form autocomplete="off">
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="row mt-4">
                                <div class="col-md-6 col-12">
                                    <small id="LblCode">کد کارگاه</small>
                                    <input type="number" class="form-control InputText  required" dir="ltr"
                                        v-model="DataAxios.Code" />
                                </div>
                                <div class="col-md-6 col-12">
                                    <small id="LblName">نام کارگاه</small>
                                    <input type="text" class="form-control InputText required"
                                        v-model="DataAxios.Name" />
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-md-6 col-12">
                                    <small id="Lblboss">نام کارفرما </small>
                                    <input type="text" class="form-control InputText required"
                                        v-model="DataAxios.Boss" />
                                </div>
                                <div class="col-md-6 col-12">
                                    <small id="LblpeymanRow"> ردیف پیمان </small>
                                    <input type="text" dir="ltr" class="form-control InputText " v-model="DataAxios.PeymanRow" />
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-md-6 col-12">
                                    <small id="number"> نرخ حق بیمه %</small>
                                    <input type="text" dir="ltr" class="form-control InputText required" v-model="DataAxios.InsFee" />
                                </div>
                                <div class="col-md-6 col-12">
                                    <small id="Lbladdress">آدرس کارگاه</small>
                                    <textarea rows="3" type="text" id="TaskDes" class="form-control InputText required"
                                        v-model="DataAxios.Address"></textarea>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-md-6 col-12">
                                <small id="LblBossFactorGrp10"> ضریب کارفرما </small>
                                <SearchableCombo :edit="false" :grp="10" :code="null" @ResultCombo="GetBossFactorGrp10" :defaultvalue="DataAxios.BossFactorGrp10" :rownumintable="3" :action="'TblSalaryCombo/GetComboById'" :method="'POST'" :idinput="'BossFactorGrp10'" :keyItem="'BossFactorGrp10'"  :ClassProps="'required'"> </SearchableCombo>
                                </div>
                                <div class="col-md-6 col-12">
                                <small id="LblBenefitFactorGrp11"> معیار محاسبه مزایا </small>
                                <SearchableCombo :edit="false" :grp="11" :code="null" @ResultCombo="GetBenefitFactorGrp11" :defaultvalue="DataAxios.BenefitFactorGrp11" :rownumintable="3" :action="'TblSalaryCombo/GetComboById'" :method="'POST'" :idinput="'BenefitFactorGrp11'" :keyItem="'BenefitFactorGrp11'"  :ClassProps="'required'"> </SearchableCombo>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <div v-if="DataAxios.blAttachmentId==null" class="col-md-9 col-12 float-left">
                                <small>بارگذاری لوگو</small>
                                <uploader @upload="GetFile"></uploader>
                            </div>
                        </div>
                    </div>


                </form>
                 <hr />
                <button v-if="$route.params.Status == 'Add' " class="btn btn-success mr-5" @click.prevent="SaveDeta()">ثبت اطلاعات</button>
                <button v-if="$route.params.Status == 'Edit'" class="btn btn-success mr-5" @click.prevent="SaveEditDeta()">ثبت تغییرات</button>
                <button id="btnCancel" class="btn btn-warning m-2" @click.prevent="Cancel()">انصراف</button>
            </template>
        </card>
    </div>
</template>
<script>
    import Card from '@/components/Card/Card.vue'
    import Uploader from '@/components/Uploader/Uploader.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'

    export default {
        components: {
            Card,
            Uploader,SearchableCombo
        },
        data() {
            return {
                DataAxios: {},
                title: '',
                File: null,
                DataAxiosPost: {
                    ArryfildValue: {},
                    Method: 'post',
                    Action: '',
                    Token: this.$session.get('Token'),
                    From: 'Body',
                },
                DataAxiosUpdate: {
                    ArryfildValue: {},
                    Method: 'put',
                    Action: '',
                    Token: this.$session.get('Token'),
                    From: 'Body',
                },
            }
        },
        created() {
            if (this.$route.params.Status == 'Add') {
                this.title = 'اضافه کردن کارگاه'
            } else {
                this.title = 'ویـرایـش کارگاه'
            }
        },
        mounted() {
            if (this.$route.params.Status == 'Add') {
                this.DataAxios.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
            }
            if (this.$route.params.Status == 'Edit') {
                this.DataAxios = this.$route.params.DataRow
                this.DataAxios.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
                this.$store.state.OldDataForLog = JSON.stringify(this.DataAxios)
            }
        },
        methods: {
            GetFile(data) {
                this.File = data
            },
             GetBossFactorGrp10(data) {
                if (data.id != null) {
                    this.DataAxios.BossFactorGrp10 = data.id
                }
            },
            GetBenefitFactorGrp11(data){
                if (data.id != null) {
                    this.DataAxios.BenefitFactorGrp11 = data.id
                }
            },
    SaveDeta() {
      if (this.$ValidForm(this.$route.name)) {
         var formData = new FormData()
        formData.append('File', this.File)
        this.DataAxiosPost.Action = 'Workshop'
        for (const [key, value] of Object.entries(this.DataAxios)) {
            formData.append(`${key}`,`${value}`)
        }
        this.DataAxiosPost.ArryfildValue = formData
       
        this.$PostFormData(this.DataAxiosPost).then((data) => {
          if (data.IsSuccess == true) {
              this.$toasted.success('کارگاه با موفقیت ایجاد شد', {
                action: {
                  text: 'بستن',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  },
                },
              })
              this.Cancel()
          } 
          else {
            if (data.IsSuccess == false) {
                this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
            }
          }
        })
      }
    },
     SaveEditDeta() {
        var formData = new FormData()
      formData.append('File', this.File)
        this.DataAxiosUpdate.Action = 'Workshop'
         for (const [key, value] of Object.entries(this.DataAxios)) {
            formData.append(`${key}`,`${value}`)
        }
        this.DataAxiosUpdate.ArryfildValue = formData
        this.$PostFormData(this.DataAxiosUpdate)
          .then((data) => {
            if (data.IsSuccess == true) {
                this.$SetLog(this.DataAxios, 0)
                this.$toasted.success('اطلاعات کارگاه با موفقیت تغییر یافت', {
                  action: {
                    text: 'بستن',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    },
                  },
                }) 
                this.Cancel()
            } else {
              if (data.IsSuccess == false) {
                this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
            }
            }
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          })
     },
    Cancel() {
        this.$router.go(-1)
    },
        }
    }
</script>
<style scoped>

</style>